import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import TabContainer from "../../../Component/Common/TabContainer";
import createstore from "../../../store";
import ChangePassword from "./ChangePassword";

// function TabContainer(props) {
//     return <Typography component="div">{props.children}</Typography>;
// }

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  grow: {
    flexGrow: 1,
  },
});

class ChangePwdTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      showOldPassword: false,
      showNewPassword: false,
      Modules: ["changepassword", "accountdetails", "changepasswordsuccess"],
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage(this.state.Modules[this.state.value]);
    const { AuthenticationAction } = createstore.getState();
    if (!AuthenticationAction.IsFulfilled) {
      this.Navigate("/");
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.ChangeLanguage(this.state.Modules[value]);
  };

  Navigate(url) {
    this.props.history.push(url);
    return false;
  }

  render() {
    const { value, Modules } = this.state;
    const language = this.props.Language[Modules[value]] || {};

    return (
      <IntlProvider locale="en" messages={language}>
        <main className="content-outer-wrapper">
          <div>
            <Grid container>
              {/* <div position="static" color="default" className={classNames(classes.root, "width100", "bottom-border")}>
                                <Tabs
                                    value={value} onChange={() => this.handleChange.bind(this)}
                                    indicatorColor="primary" textColor="primary"
                                    scrollButtons="auto" className="master-sh" >
                                    <Tab label={<FormattedMessage id="TbUpdatePassword" defaultMessage="Update Password" />} className="subtitle-1" />

                                </Tabs>
                            </div>
                            {value === 0 && (
                                <TabContainer>
                                    <ChangePassword parentHistory={this.props.parentHistory} history={this.props.history} />
                                </TabContainer>
                            )} */}
              <ChangePassword
                parentHistory={this.props.parentHistory}
                history={this.props.history}
              />
            </Grid>
          </div>
        </main>
      </IntlProvider>
    );
  }
}
ChangePwdTab.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ChangePwdTab));
